export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1514557718210-26e452f8fab0?crop=entropy&cs=srgb&fm=jpg&q=85",
  heroAlt: "https://images.unsplash.com/photo-1549483249-f0b359d1e289?crop=entropy&cs=srgb&fm=jpg&q=85",
  cityNight: "https://images.unsplash.com/photo-1712873068978-eb0cb20d1b62?crop=entropy&cs=srgb&fm=jpg&q=85",
  boardroom: "https://images.unsplash.com/photo-1758691736424-4b4273948341?crop=entropy&cs=srgb&fm=jpg&q=85",
  strategy: "https://images.unsplash.com/photo-1758518730083-4c12527b6742?crop=entropy&cs=srgb&fm=jpg&q=85",
  executive: "https://images.unsplash.com/photo-1771147372634-976f022c0033?crop=entropy&cs=srgb&fm=jpg&q=85",
  workshop: "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?crop=entropy&cs=srgb&fm=jpg&q=85",
  keynote: "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?crop=entropy&cs=srgb&fm=jpg&q=85",
  stage: "https://images.unsplash.com/photo-1559223694-98ed5e272fef?crop=entropy&cs=srgb&fm=jpg&q=85",
  ai: "https://images.unsplash.com/photo-1644088379091-d574269d422f?crop=entropy&cs=srgb&fm=jpg&q=85",
  data: "https://images.unsplash.com/photo-1561233835-f937539b95b9?crop=entropy&cs=srgb&fm=jpg&q=85",
  particles: "https://images.unsplash.com/photo-1757466762489-52fea38071ad?crop=entropy&cs=srgb&fm=jpg&q=85",
};

export const youtubeId = (url = "") => {
  const m = url.match(/(?:youtu\.be\/|v=|embed\/|shorts\/)([A-Za-z0-9_-]{11})/);
  return m ? m[1] : "";
};

export const ytThumb = (url) => {
  const id = youtubeId(url);
  return id ? `https://i.ytimg.com/vi/${id}/hqdefault.jpg` : "";
};

export const ytEmbed = (url) => {
  const id = youtubeId(url);
  return id ? `https://www.youtube.com/embed/${id}?autoplay=1` : "";
};

export const imageUrl = (src) => {
  if (!src) return "";
  if (src.startsWith("http")) return src;
  return `${process.env.REACT_APP_BACKEND_URL}/api/media/${src}`;
};
